import { Height } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { Box } from "@mui/system";
import React from "react";
/* import { Link } from "react-router-dom"; */

const Project = ({
  title,
  description,
  tags,
  img,
  source,
  liveVersion,
  id,
  hidden,
}) => {
  return (
    <Card
      sx={{
        maxWidth: 375,
        margin: "1rem",
        border: "3px solid #B3565B",
        display: hidden,
      }}
    >
      <a href={liveVersion} target="_blank" rel="noopener">
        <CardActionArea>
          <CardMedia component="img" image={img} sx={{ height: 210 }} />
          <CardContent sx={{ minHeight: 230 }}>
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </a>
      <CardActions sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
            mx: "auto",
            mb: 3,
          }}
        >
          {liveVersion !== "" ? (
            <a href={liveVersion} target="_blank" rel="noopener">
              <Button
                size="small"
                style={{ backgroundColor: "#B3565B" }}
                variant="contained"
              >
                Hemsida Live
              </Button>
            </a>
          ) : (
            <Button
              size="small"
              style={{ backgroundColor: "#B3565B" }}
              variant="contained"
            >
              Kommer snart
            </Button>
          )}

          {source !== "" && (
            <a href={source} target="_blank" rel="noopener">
              <Button
                size="small"
                style={{ backgroundColor: "#B3565B" }}
                variant="contained"
              >
                Kod Github
              </Button>
            </a>
          )}
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "1rem",
            mb: 2,
          }}
        >
          {tags.map((tag) => (
            <Chip
              label={tag}
              variant="outlined"
              key={tag}
              sx={{ backgroundColor: "#f7d0d1", border: "none" }}
            />
          ))}
        </Box>
      </CardActions>
    </Card>
  );
};

export default Project;
